import { storyblokEditable } from "gatsby-source-storyblok"

import BenefitDriver from "../../../V2/Lab/BenefitDriver"

import { storyblokLinkToYocoLink } from "@utils/storyblok"
import React from "react"

const BenefitDriverStoryblok = ({
  blok,
}: Storyblok.BlokProps<Storyblok.BenefitDriver>) => {
  const tabs = blok.tabs.map((tab) => ({
    leadText: tab.leadText,
    bodyText: tab.bodyText,
    image: tab.image?.filename,
    imageAlt: tab.image?.alt,
    video: storyblokLinkToYocoLink(tab.video as Storyblok.Link)?.url ?? "",
    ctaText: tab.ctaText,
    ctaLink: storyblokLinkToYocoLink(tab.ctaLink),
  }))

  const blokHeading = blok.heading?.[0] || ({} as Storyblok.LayoutHeading)

  return (
    <BenefitDriver
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
      mode={blok.mode}
      heading={{
        ...blokHeading,
        size: blokHeading?.size || "large",
        alignment: blokHeading?.alignment || "left",
        mobileAlignment: blokHeading?.mobileAlignment || "left",
        callout: blokHeading?.callout?.[0],
      }}
      description={blok.description}
      tabs={tabs}
      isNumbered={blok.isNumbered}
      buttonText={blok.ctaText}
      showDownloadAppButton={blok.showDownloadAppButton}
      buttonUrl={
        !blok.showDownloadAppButton
          ? storyblokLinkToYocoLink(blok.ctaLink)
          : undefined
      }
      trackingEvent={blok.trackingEvent}
      trackingEventKey={blok.trackingEventKey}
      trackingEventValue={blok.trackingEventValue}
      mobileHeadingAlignment={blok.mobileHeadingAlignment}
      desktopLabelAlignment={blok.desktopLabelAlignment}
      centerLabels={blok.centerLabels}
      id={blok.id}
    />
  )
}

export default BenefitDriverStoryblok
